// Initialize Firebase
var config = {
  apiKey: "AIzaSyCtSfIQyZua3V5lpmthL-Q49trkv9phV4g",
  authDomain: "webstructrual.firebaseapp.com",
  databaseURL: "https://webstructrual.firebaseio.com",
  projectId: "webstructrual",
  storageBucket: "webstructrual.appspot.com",
  messagingSenderId: "157062586915"
}

firebase.initializeApp(config)

function handleQueryParameters() {
  var queryStr = window.location.search;
  var paramPairs = queryStr.substr(1).split('&');
  var params = {};

  for (var i = 0; i < paramPairs.length; i++) {
      var parts = paramPairs[i].split('=');
      params[parts[0]] = parts[1];
      // ./beam-designer.html?login=true
      if(parts[0] == 'login' && parts[1] == 'true') {
          openSigninModal();
      } else if(parts[0] == 'sign-up' && parts[1] == 'true') {
          openSignupModal();
      }
  }
}

function initializeFirebaseAuth() {

  firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL)

  firebase.auth().onAuthStateChanged(function(user) {
      if (user) {
          onLoginSuccess(user);
          checkStripeSubscription();
      } else {
          onLogoutSuccess();
      }
  });
}


function customerGate() {

  // logged in and upgraded
  if(firebase.auth().currentUser && customerLevel === 'pro') {
      return false
  }
  
  // not logged in
  if(firebase.auth().currentUser === null) {
      openSigninModal()
      return true
  }

  if(customerLevel === "basic") {
      openFinishUpgradeModal()
      return true
  }

  // free or not set
  openSignupModal()
  return true
}

function configureShapeSelector() {
  if(activeProject.shape.flitch) {
      initializeFlitchBeam(activeProject)
  }
}
